import apiClient from './apiClient';
import { getServerUrl } from '../utils';
import { customerEndpoints } from '../constants/endpoint';

export const createCustomer = (payload) =>
  apiClient(getServerUrl()).post(customerEndpoints.create, payload);

export const fetchCustomer = () =>
  apiClient(getServerUrl()).get(customerEndpoints.create);

export const updateCustomer = (payload) =>
  apiClient(getServerUrl()).put(`${customerEndpoints.create}/${payload.id}`, payload);

export const deleteCustomer = (customerId) =>
  apiClient(getServerUrl()).delete(`${customerEndpoints.create}/${customerId}`);
